import {
  LockOutlined as LockIcon,
  QrCode2 as QrIcon,
} from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { Form, required, TextInput, useLogin, useNotify } from 'react-admin';

export function LoginPage() {
  const login = useLogin();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: Record<string, string>) => {
    setLoading(true);
    try {
      await login(values);
    } catch (err) {
      notify((err as Error).message || 'Invalid email or password', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1C2833 0%, #1A5276 50%, #C0392B 100%)',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 420 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
            <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56, mb: 2 }}>
              <QrIcon fontSize="large" />
            </Avatar>
            <Typography variant="h5" fontWeight={700}>
              QRBusiness India
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Admin Panel
            </Typography>
          </Box>

          <Form onSubmit={handleSubmit} defaultValues={{ username: '', password: '' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextInput
                source="username"
                label="Email"
                autoComplete="email"
                fullWidth
                validate={required()}
              />
              <TextInput
                source="password"
                label="Password"
                type="password"
                autoComplete="current-password"
                fullWidth
                validate={required()}
              />
              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                disabled={loading}
                startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <LockIcon />}
                sx={{ mt: 1 }}
              >
                {loading ? 'Signing in…' : 'Sign in'}
              </Button>
            </Box>
          </Form>
        </CardContent>
      </Card>
    </Box>
  );
}
